module.exports = __webpack_public_path__ + "static/scale-model-of-buffalo-new-york-41c860d45d1a399ec2180e967dba89f6.png";